import { forwardRef, ReactNode } from "react";

// @mui
import { Box, Typography, Button, IconButton } from "@mui/material";

// Components
import CloseIcon from "@mui/icons-material/Close";
import CustomIcon from "components/CustomIcon";
import CTA from "components/Pro/CTA";

// Hooks
import { useIntl } from "react-intl";

// Styles
import useStyles from "./MessageUpgrade.styles";
import { title } from "process";
import React from "react";

const MessageUpgrade = forwardRef(function MessageUpgrade(
    {
        width = "70%",
        variant = "type1",
        onClose,
        icon,
        title,
        subtitle,
        descriptionTitle,
        children,
        hasButtonIcon,
    }: {
        width?: string | number;
        variant?: "type1" | "type2" | "type3";
        icon?: JSX.Element;
        title: ReactNode | string;
        subtitle?: ReactNode | string;
        descriptionTitle?: ReactNode;
        onClose?: (event: React.MouseEvent) => void;
        children?: React.ReactNode;
        hasButtonIcon?: boolean;
    },
    ref
) {
    const intl = useIntl();
    const classes = useStyles({ variant });
    const isDetailed = variant === "type2" || variant === "type3";

    return (
        <Box className={classes.upgradeMsgContainer} width={width} ref={ref}>
            <Box display="flex" justifyContent="space-between" marginBottom={1}>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                    {icon && <CustomIcon icon={icon} />}
                    <Typography pl={1} component="strong" sx={{ fontSize: 20 }}>
                        {intl.formatMessage({ id: `${title}` })}
                    </Typography>
                </Box>

                {onClose && (
                    <IconButton className={classes.upgradeMsgHeaderCloseBtn} size="small" onClick={onClose}>
                        <CloseIcon fontSize="small" />
                    </IconButton>
                )}
            </Box>

            {subtitle && (
                <Typography sx={{ fontSize: 16, mb: 1 }}>{intl.formatMessage({ id: `${subtitle}` })}</Typography>
            )}

            {isDetailed ? (
                <Box className={classes.upgradeMsgDetails}>
                    <Box className={classes.upgradeMsgDetailsHeading}>
                        <Typography variant="overline" sx={{ fontWeight: 600 }}>
                            {intl.formatMessage({ id: `${descriptionTitle}` })}
                        </Typography>
                    </Box>
                    <Box className={classes.upgradeMsgDetailsExplainerText}>{children}</Box>
                </Box>
            ) : (
                children
            )}

            <Box display="flex" justifyContent="flex-end">
                <CTA
                    hasButtonIcon={hasButtonIcon}
                    variant="message"
                    text={
                        variant === "type3"
                            ? intl.formatMessage({ id: "paceDashboard.unlockBenchmark.getInTouch" })
                            : intl.formatMessage({ id: "pro.message.button.goPro" })
                    }
                />
                {onClose && variant !== "type3" ? (
                    <Box>
                        <Button
                            variant="text"
                            className={classes.upgradeBtn}
                            sx={{ color: "others.white" }}
                            onClick={onClose}
                        >
                            {intl.formatMessage({
                                id: "pro.message.button.goBack",
                            })}
                        </Button>
                    </Box>
                ) : null}
            </Box>
        </Box>
    );
});

export default MessageUpgrade;
